<template>
  <span v-show="show" :class="styles">{{formatted}}</span>
</template>

<script>
export default {
  name: 'mv-msg-count',
  props: ['count', 'inverse', 'hidenil', 'transport'],
  computed: {
    formatted () {
      return (this.count || 0).toString() + (this.transport || '')
    },
    styles () {
      return 'mvmsgc' +
      (this.transport === 'sms' ? ' mvmsgc-sms' : ' mvmsgc-email') +
      (this.inverse === '' ? ' mvmsgc-inverse' : '')
    },
    show () {
      return !(this.hidenil === '' && !this.count)
    }
  }
}
</script>

<style lang="css">
.mvmsgc {
  display: inline-block;
  min-width: 60px;
  font-family: 'Roboto Mono', monospace !important;
  font-weight: 500;
  text-align: center;
  padding: 3px;
}
.mvmsgc-email {
  color: #ed5381;
}
.mvmsgc-sms {
  color: #5fb2e2;
}
.mvmsgc-inverse {

}
.mvmsgc-email.mvmsgc-inverse {
  background-color: #ed5381;
  color: white;
}
.mvmsgc-sms.mvmsgc-inverse {
  background-color: #5fb2e2;
  color: white;
}
</style>
